import { Link } from 'react-router-dom';
import styles from './FeatureDisabledPage.module.css';

interface FeatureDisabledPageProps {
  featureName: string;
}

export function FeatureDisabledPage({ featureName }: FeatureDisabledPageProps) {
  return (
    <div className={styles.featureDisabledPage}>
      <div className={styles.icon}>🔒</div>
      <h1 className={styles.title}>功能已停用</h1>
      <p className={styles.message}>
        「{featureName}」功能目前暫停服務，請稍後再試。
      </p>
      <Link to="/" className={styles.backButton}>
        返回首頁
      </Link>
    </div>
  );
}
